var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "bynder-image-editor-publish-modal",
            "no-close-on-backdrop": "",
            title: "Publish to Bynder",
            centered: "",
            size: "lg",
          },
          on: { shown: _vm.handleModalShown, hide: _vm.handleModalHide },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isPublishing || !_vm.platformId,
                          },
                          on: { click: _vm.handlePublish },
                        },
                        [
                          _vm.isPublishing
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isPublishing
                                  ? "Publishing..."
                                  : "Publish to Bynder"
                              ) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _vm.fileName
              ? _c("div", { staticClass: "mt-3" }, [
                  _c("h5", [
                    _vm._v("Publish: "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.fileName)),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            { staticClass: "mb-3" },
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Platform",
                                "label-for": "platform-select",
                                "label-class": "mb-1",
                              },
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  attrs: { id: "platform-select", size: "sm" },
                                  model: {
                                    value: _vm.platformId,
                                    callback: function ($$v) {
                                      _vm.platformId = $$v
                                    },
                                    expression: "platformId",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select-option",
                                    {
                                      attrs: {
                                        value: "",
                                        disabled: "",
                                        selected: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Select Platform\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.platforms, function (platform) {
                                    return _c(
                                      "b-form-select-option",
                                      {
                                        key: platform.id,
                                        attrs: { value: platform.id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(platform.name) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "DPI",
                                "label-for": "dpi-select",
                                "label-class": "mb-1",
                              },
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  attrs: { id: "dpi-select", size: "sm" },
                                  model: {
                                    value: _vm.dpi,
                                    callback: function ($$v) {
                                      _vm.dpi = $$v
                                    },
                                    expression: "dpi",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "72" } },
                                    [
                                      _vm._v(
                                        "\n                  72\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "75" } },
                                    [
                                      _vm._v(
                                        "\n                  75\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "100" } },
                                    [
                                      _vm._v(
                                        "\n                  100\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "144" } },
                                    [
                                      _vm._v(
                                        "\n                  144\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "150" } },
                                    [
                                      _vm._v(
                                        "\n                  150\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "200" } },
                                    [
                                      _vm._v(
                                        "\n                  200\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "300" } },
                                    [
                                      _vm._v(
                                        "\n                  300\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Format",
                                "label-for": "format-select",
                                "label-class": "mb-1",
                              },
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  attrs: { id: "format-select", size: "sm" },
                                  model: {
                                    value: _vm.imageType,
                                    callback: function ($$v) {
                                      _vm.imageType = $$v
                                    },
                                    expression: "imageType",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "jpeg" } },
                                    [
                                      _vm._v(
                                        "\n                  JPG\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: "png" } },
                                    [
                                      _vm._v(
                                        "\n                  PNG\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }